window.timerMinutes = 1000 * 60 * 10, // timer minutes in miliseconds
window.startTimerInterval = null;
window.startTimer = function(duration, display, getLSTime) {
  console.log(getLSTime, 'getTime');
  var getTime = parseInt(getLSTime),
      start = Date.now(), diff, minutes, seconds;
  function timer() {
      diff = duration - (((Date.now() - getTime) / 1000) | 0);

      minutes = (diff / 60) | 0;
      seconds = (diff % 60) | 0;

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      display.querySelector('#minute').textContent = minutes;
      display.querySelector('#second').textContent = seconds;

      if (diff <= 0) {
        display.closest('.early-timer--banner').style.display = 'none';
        clearCart(false);
      }
  };
  timer();
  window.startTimerInterval = setInterval(timer, 1000);
}

// Set the cookie to the new time        
function clearCart(setC = false) {
  fetch(window.Shopify.routes.root + 'cart/clear.js', {
    method: 'POST',
  })
  .then((response) => response.json())
  .then((response) => {
    console.log('Cart Cleared');
    localStorage.removeItem('cart-reserved-time');
    location.reload();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function clearCookiewithoutLoad(getLSTime) {
  console.log('Current time greater than localstorage time: ', Date.now() > getLSTime);
  
  if (parseInt(Date.now()) > getLSTime && getLSTime != null) {
    clearCart(false);
  } else {
    // setTimeout(function(){
    //   clearCookiewithoutLoad(getLSTime);
    // }, 1);
  }
}

(function(ns, fetch) {
  if (typeof fetch !== 'function') return;

  ns.fetch = function() {
    var out = fetch.apply(this, arguments);

    out.then(({ ok }) => {
      if (arguments[0].indexOf('/cart/add') > -1) {
        localStorage.setItem('cart-reserved-time', Date.now());
        if (document.querySelector('.timer-clock-wrapper') && arguments[0].indexOf('/cart/add') > -1) {
          clearInterval(window.startTimerInterval);
          window.startTimer(window.timerMinutes / 1000, 
            document.querySelector('.timer-clock-wrapper'), 
            localStorage.getItem('cart-reserved-time'));
        }
      } else if (arguments[0].indexOf('/cart/update') > -1) {
        // localStorage.setItem('cart-reserved-time', Date.now());
      }
    });

    return out;
  }
}(window, window.fetch));

document.addEventListener("DOMContentLoaded", (event) => {
  if (document.querySelector('.timer-clock-wrapper')) {
      window.startTimer(window.timerMinutes / 1000, 
        document.querySelector('.timer-clock-wrapper'), 
        localStorage.getItem('cart-reserved-time'));
  }

  var localStorage_time = localStorage.getItem('cart-reserved-time');
      console.log('localStorage Get: ', localStorage_time);
  
  if (localStorage_time != null && localStorage_time != undefined) {
    var getLSTime = parseInt(localStorage_time) + window.timerMinutes;
    clearCookiewithoutLoad(getLSTime);
  }
});